import { combineReducers } from 'redux';
import GroupNumberReducer from './groupNumberReducer';

const rootReducer = combineReducers({
    groupNumberReducer: GroupNumberReducer
})

export default rootReducer;